import { useEffect, useState, Dispatch, SetStateAction } from "react";
import { debug, RequestResult, RIF } from "../../lib";
import { useCreateDispatchActions, useSelectMethod, useSelectTheme } from "../../store";
import { ParticipantPopupOperationType, PopupSimple, PopupSize, PopupTemplate } from "..";
import { IParticipant } from "../../shared/db";

export const PopupRegenerateInviteCode = (props: {
  setOperationType: Dispatch<SetStateAction<ParticipantPopupOperationType | null>>;
  setRegenerateCode: Dispatch<SetStateAction<Record<string, string>>>;
  participant: IParticipant | null;
}) => {
  const { color } = useSelectTheme();
  const method = useSelectMethod();
  const garminConnectEnable = method?.garminConnectEnable ?? false;
  const { setOperationType, participant, setRegenerateCode } = props;
  const handleClosePopup = () => {
    setOperationType(null);
  };
  const { doREQUEST_PARTICIPANT_CREDENTIALS_REGENERATE } = useCreateDispatchActions();
  const [requestResult, setRequestResult] = useState<RequestResult | null>(null);

  const handleSubmit = (data: any) => {
    debug("PopupRegenerateInviteCode.onSubmit", { data });
    doREQUEST_PARTICIPANT_CREDENTIALS_REGENERATE({
      setRequestResult,
      payload: {
        participantId: participant?.id,
      },
    });
  };

  useEffect(() => {
    if (!requestResult?.success) return;
    // setRegenerateCode(requestComplete?.payload?.payload?.credentials?.loginCode)
    setRegenerateCode((prev) => {
      if (!participant?.id) {
        return prev;
      } else {
        return {
          ...prev,
          [participant.id]: requestResult?.result.payload?.credentials?.loginCode,
        };
      }
    });
    handleClosePopup();
  }, [requestResult]);

  return (
    <PopupTemplate
      {...{
        title: "Regenerate Invite Code",
        description: (
          <>
            <p css={{ color: color.textIcon.warning }}>
              Must be the same participant: To ensure data completeness, correctness, and
              compliance, do not reuse a slot for a different participant. Some algorithms use
              existing baseline metrics and mixing people will result in incorrect and mixed data,
              meaning all data in the account could become unusable.
            </p>
            {RIF(
              garminConnectEnable,
              <p>
                Note: If you are reusing a Garmin device, in addition to creating a new Labfront
                participant, make sure to reset the Garmin device and use a new Garmin Connect
                account since Garmin Connect uses historical data in some algorithms. Mixing up
                could result in unusable data.
              </p>,
            )}
          </>
        ),
        background: true,
        popupSize: PopupSize.Small,
        handleClosePopup,
        mainFunction: handleSubmit,
        buttonContent: "Regenerate Code",
      }}
    />
  );
};
